import React from "react";

const features = [
  { icon: "⚡", title: "Fast & Accurate", description: "Get instant insights powered by live chart data." },
  { icon: "🧠", title: "Trained on Traders", description: "Built using real scenarios faced by traders and investors." },
  { icon: "🔍", title: "Focused Explanations", description: "Agents keep it simple and relevant to the market moment." },
  { icon: "🎯", title: "Actionable Insights", description: "Each reply ends with a hint or question to spark action." },
];

const AgentsFeaturesSection = () => {
  return (
    <section className="features">
      <div className="container">
        <h2>Why FinTorro AI Agents Stand Out</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              className="feature-item"
              key={index}
              onClick={() => window.location.href = "/agent-access"}
              style={{ cursor: "pointer" }}
            >
              <span className="icon-placeholder">{feature.icon}</span>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AgentsFeaturesSection;
